<div class="admin-report-sidebar h-100 w-100">
  <div class="w-100">
    <nav class="nav flex-column">
      <a class="nav-link text-dark font-weight-bold mb-5" routerLink="/admin_dashboard"><i class="fas fa-home"></i> Home</a>
      <a class="nav-link text-dark font-weight-bold mb-5" routerLink="#"> <i class="fas fa-mobile-alt"></i> Mobile App</a>
      <a class="nav-link text-dark font-weight-bold mb-5" routerLink="#"><i class="fas fa-user"></i> Accounts</a>
      <a class="nav-link text-dark font-weight-bold disabled" routerLink="/report_page"> <i class="fas fa-file-alt"></i> Reports</a>
    </nav>
  </div>
</div>

